var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feet-r" },
    [
      _c(
        "el-button",
        {
          attrs: {
            icon: "el-icon-download",
            size: "small",
            type: "primary",
            loading: _vm.loading,
          },
          on: {
            click: function ($event) {
              return _vm.operationBtn()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("receivablePayable.DownloadTheTemplate")))]
      ),
      _c("upload-excel", {
        attrs: {
          "on-success": _vm.importLogistics,
          "but-name": _vm.$t("receivablePayable.ImportCalculatePrices"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }